import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.247 3.745a.75.75 0 0 1 .75-.75h7.125a4.875 4.875 0 0 1 3.346 8.42 5.25 5.25 0 0 1-2.97 9.58H5.996a.75.75 0 0 1-.75-.75zm3 9v6h4.5a3 3 0 0 0 0-6zm0-2.25h4.125a2.625 2.625 0 0 0 0-5.25H8.247z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }